import { CSSProperties } from 'react';
import { InternalApiFinalRiskLevel } from '../api-internal';

export const RISK_LEVEL_CSS_VARS: Record<InternalApiFinalRiskLevel, string> = {
  [InternalApiFinalRiskLevel.LOW]: '--success',
  [InternalApiFinalRiskLevel.LOW_TO_MEDIUM]: '--warning',
  [InternalApiFinalRiskLevel.MEDIUM]: '--warning',
  [InternalApiFinalRiskLevel.MEDIUM_TO_HIGH]: '--warning',
  [InternalApiFinalRiskLevel.HIGH]: '--danger',
  [InternalApiFinalRiskLevel.UNACCEPTABLE]: '--danger-active',
};

export const riskLevelColourStyle = (level?: InternalApiFinalRiskLevel): CSSProperties | undefined =>
  level ? { color: `var(${RISK_LEVEL_CSS_VARS[level]})` } : undefined;
